/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Core
import { PropTypes } from "prop-types";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";

// Context
import { SoftUIControllerProvider } from "context";

// Redux
import store from "state/store";

function Providers({ children }) {
  const persistor = persistStore(store);

  return (
    <BrowserRouter>
      <SoftUIControllerProvider>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            {children}
          </PersistGate>
        </Provider>
      </SoftUIControllerProvider>
    </BrowserRouter>
  );
}

// Setting default values for the props of Alert
Providers.defaultProps = {};

// Typechecking props of the Alert
Providers.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Providers;
